import React from 'react'

type Props = {
  children: React.ReactNode
  name?: string
  fallback?: React.ReactNode
  onError?: (error: Error, info: React.ErrorInfo) => void
}

type State = { error: Error | null }

export default class ErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error) {
    return { error }
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    this.props.onError?.(error, info)
    const boundaryName = this.props.name || 'ErrorBoundary'
    console.error(boundaryName, error, info)
  }

  render() {
    if (this.state.error) {
      return this.props.fallback ?? (
        <div className="rounded-xl border border-white/10 bg-white/5 p-4 text-sm text-white/80">
          Something went wrong loading this section.
        </div>
      )
    }
    return this.props.children
  }
}
